<template>
  <div>
    <modal-box
      :is-active="isModalActive"
      :trash-object-name="trashObjectName"
      @confirm="trashConfirm"
      @cancel="trashCancel"
    />

    <CitizenDetailsUpdate
      v-if="isEditDetailsModalActive"
      :isOpen="isEditDetailsModalActive"
      slot="button"
      class="level-item"
      @cancel="editDetailsCancel"
      :selectedCitizen="editDetailsObject"
      :key="renderDetailsKey"
    />
    <UpdateCitizenModal
      v-if="isEditModalActive"
      :isOpen="isEditModalActive"
      slot="button"
      class="level-item"
      @cancel="editCancel"
      :selectedCitizen="editObject"
      :key="renderUpdateKey"
    />
    <UpdateFormStatusModal
      v-if="isEditStatusModalActive"
      :isOpen="isEditStatusModalActive"
      slot="button"
      class="level-item"
      @cancel="editStatusCancel"
      :selectedCitizen="editStatusObject"
      :key="renderFormKey"
    />
        <ViewCitizenModal
    v-if="isViewModalActive"
    :isOpen="isViewModalActive"
    @cancel="viewCancel"
    :selectedCitizen="viewObject"
    />
    <b-table
      :checkable="checkable"
      :loading="isLoading"
      paginated
      backend-pagination
      @page-change="onPageChange"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      backend-sorting
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      @sort="onSort"
      :total="totalCitizenItems"
      :per-page="perPage"
      :striped="true"
      :hoverable="true"
      :current-page="currentPage"
      :data="citizens"
      cell-class="cell-class"
      scrollable
    >
       <template slot-scope="props">
        <b-table-column label = "Actions" name = "actions" custom-key="actions" class="is-actions-cell">
          <div class="buttons is-left">
          <div class="column is-half">
            <button
              class="button is-small is-primary"
              type="button"
              @click.prevent="editDetailsModal(props.row)"
            >
            <b-icon pack="fas" icon="pencil-alt" custom-size="default" />
            </button>
            <div class="check-citizen" v-if="$store.state.auth.user.role == 1 && (props.row.form_status == 'Verified' ||
              props.row.form_status == 'Pending')">
            <button
              class="button is-small is-primary"
              type="button"
              @click.prevent="editModal(props.row)"
            >
              <b-icon pack="fas" icon="user-check" custom-size="default" />
            </button>
            </div>
            <div class="check-citizen" v-if="$store.state.auth.user.role == 2 && (props.row.form_status == 'Unverified' ||
            props.row.form_status == 'Pending'
            )">
            <button
              class="button is-small is-primary"
              type="button"
              @click.prevent="editStatusModal(props.row)"
            >
              <b-icon pack="fas" icon="user-check" custom-size="default" />
            </button>
            </div>
          </div>
          <div class="column is-half">
            
            <button
              class="button is-small is-primary"
              type="button"
              @click.prevent="viewModal(props.row)"
            >
            <b-icon pack="fas" icon="eye" custom-size="default" />
            </button>
            <!-- <template v-else>
              <button
              class="button is-small is-primary"
              type="button"
              @click.prevent="editModal(props.row)"
            >
              <b-icon pack="fas" icon="pencil-alt" custom-size="default" />
            </button>
            </template> -->

            <button
              class="button is-small is-danger"
              type="button"
              @click.prevent="trashModal(props.row)"
            >
              <b-icon icon="trash-alt" custom-size="default" />
            </button>
          </div>
          </div>
          </b-table-column>
         <b-table-column label="Name" field="full_name" class="beautify" sortable>
          <router-link :to="{name: 'user_details', params: {id: props.row._id}}" class="card-meetup-link" v-bind:class="{ external: !props.row.registered_by }">
          {{
          props.row.english_name
          }}
           </router-link>
          </b-table-column>
          <b-table-column label="Form Status" field="form_status" sortable>
         {{props.row.form_status}}
          </b-table-column>
          <b-table-column label="Shareholder No." field="share_no" class="beautify">
          {{
          props.row.verification_token
          }}
          </b-table-column>

          <b-table-column label="Email" field="email">
          {{
          props.row.email
          }}
          </b-table-column>
          <b-table-column label="Citizenship" field="citizenship" class="beautify">
          {{
          props.row.citizenship_number
          }}
          </b-table-column>
          <b-table-column label="Birth date" field="birth_date" >
          {{
          props.row.birth_date|formatDateShort
          }}
          </b-table-column>
          <b-table-column label="Father" field="father" class="beautify">
          {{
          props.row.father_name
          }}
          </b-table-column>
          <b-table-column label="Grandfather" field="Grandfather" >
          {{
          props.row.grandfather_name
          }}
          </b-table-column>
          <b-table-column label="District" field="district" class="beautify">
          {{
          props.row.district
          }}
          </b-table-column>
          <b-table-column label="Municipality" field="municipality" >
          {{
          props.row.municipality
          }}
          </b-table-column>
          <b-table-column label="ward" field="ward" class="beautify">
          {{
          props.row.ward
          }}
          </b-table-column>
          <b-table-column label="Mobile" field="mobile" >
          {{
          props.row.mobile_number
          }}
          </b-table-column>
          <b-table-column label="Phone" field="phone" class="beautify">
          {{
          props.row.phone_number
          }}
          </b-table-column>
          <b-table-column label="Permanent Address" field="permanent" >
          {{
          props.row.permanent_address
          }}
          </b-table-column>
          <b-table-column label="Temporary Address" field="temporary" class="beautify">
          {{
          props.row.temporary_address
          }}
          </b-table-column>
          <b-table-column label="Current Address" field="current" >
          {{
          props.row.current_address
          }}
          </b-table-column>
          <b-table-column label="Bank" field="bank" class="beautify">
          {{
          props.row.bank
          }}
          </b-table-column>
          <b-table-column label="Account Number" field="account" >
          {{
          props.row.account_number
          }}
          </b-table-column>
          <b-table-column label="Beneficiary Name" field="beneficiary" class="beautify">
          {{
          props.row.beneficiary_name
          }}
          </b-table-column>
          <b-table-column label="Relationship" field="relationship" >
          {{
          props.row.relationship
          }}
          </b-table-column>
          <b-table-column label="Contact" field="contact" class="beautify">
          {{
          props.row.beneficiary_contact
          }}
          </b-table-column>
          <b-table-column label="Code No." field="code" >
          {{
          props.row.code_no
          }}
          </b-table-column>
          <b-table-column label="Office Code" field="office_code" class="beautify">
          {{
          props.row.office_code_no
          }}
          </b-table-column>
          <!-- <b-table-column label="Shareholder No." field="share_no" sortable>
          {{
          props.row.verification_token
          }}
          </b-table-column> -->
          <b-table-column label="Card Status:" field="card" >
          {{
          props.row.card_status
          }}
          </b-table-column>

          <!-- <b-table-column label="Form Status" field="status">
         {{props.row.form_status}}
          </b-table-column> -->
          <!-- <template v-if="props.row.form_status == 'Yes'">
           <b-table-column label="Form Status" field="status">
          Complete
          </b-table-column>
          </template>
          <template v-else>
          <b-table-column label="Form Status" field="status">
          Incomplete
          </b-table-column>
          </template> -->


          <template v-if="props.row.verification_token">
           <b-table-column label="IsVerified" field="verified" class="beautify">
          Yes
          </b-table-column>
          </template>
          <template v-else>
          <b-table-column label="IsVerified" field="verified" class="beautify">
          No
          </b-table-column>
          </template>
          <b-table-column label="Last Modified" field="last_modified" >
          {{
            props.row.last_modified | dateConvert
          }}
          </b-table-column>
          <b-table-column label="Last Modified By" field="last_modified_by" class="beautify">
          {{
            props.row.last_modified_by
          }}
          </b-table-column>
      </template>

      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Fetching data...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p>Nothing's there&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </div>
</template>
<!--
<template>
<div>
  <div>
  <div v-for="citizen in citizens" :key="citizen._id">
          <router-link :to="{name: 'user_details', params: {id: citizen._id}}" class="card-meetup-link">
            <div class="card-image">
              <p>{{ citizen.first_name }}</p>
            </div>
          </router-link>
  </div>
  </div>
</div>
</template>
-->
<script>
import axios from 'axios';
import ModalBox from './ModalBox';
import UpdateCitizenModal from './UpdateCitizenModal';
import ViewCitizenModal from './ViewCitizenModal';
import CitizenDetailsUpdate from './CitizenDetailsUpdate';
import UpdateFormStatusModal from './UpdateFormStatusModal';

export default {
  name: 'ClientsTableSample',
  components: { ModalBox, UpdateCitizenModal, CitizenDetailsUpdate, ViewCitizenModal, UpdateFormStatusModal },
 props: {
    dataUrl: {
      type: String,
      default: null,
    },
    checkable: {
      type: Boolean,
      default: false,
    },
    searchTe: {
      type: String,
      default: null,
    }, 
    searchTy: {
      type: String,
      default: null,
    },
  },
  filters: {
    dateConvert(rowDate) {
      let date = new Date(rowDate);
      let localDate = date.getTime() ? date.toLocaleDateString() : 'Unavailable';
      return localDate;
    }
  },
  data() {
    return {
      renderDetailsKey : 0,
      renderUpdateKey: 0,
      renderFormKey: 0,
      isModalActive: false,
      isEditModalActive: false,
      isEditStatusModalActive: false,
      isViewModalActive: false,
      isEditDetailsModalActive: false,
      trashObject: null,
      editObject: null,
      editStatusObject: null,
      editDetailsObject: null,
      clients: [],
      isLoading: false,
      paginated: true,
      perPage: 10,
      currentPage: 1,
      totalItems: 60,
      sortField: 'name',
      sortOrder: '+',
      defaultSortOrder: '+',
    };
  },
  computed: {
    trashObjectName() {
      if (this.trashObject) {
        return this.trashObject;
      }

      return {};
    },
    citizens() {
      return this.$store.state.citizens.items;
    },
    totalCitizenItems() {
      return this.$store.state.citizens.total;
    },
  },
  // mounted() {
  //   this.isLoading = true;
  //   this.fetchCitizen()
  // },
  created() {
    this.form_scan = this.$store.state.citizens.form_scan
  },
  // mounted() {
  //   debugger;
  //   this.isLoading = true;
  //   this.fetchUser();

  //   // if (this.dataUrl) {
  //   //   this.isLoading = true;
  //   //   axios
  //   //     .get(this.dataUrl)
  //   //     .then(r => {
  //   //       this.isLoading = false;
  //   //       if (r.data && r.data.data) {
  //   //         if (r.data.data.length > this.perPage) {
  //   //           this.paginated = true;
  //   //         }
  //   //         this.clients = r.data.data;
  //   //       }
  //   //     })
  //   //     .catch(e => {
  //   //       this.isLoading = false;
  //   //       this.$buefy.toast.open({
  //   //         message: `Error: ${e.message}`,
  //   //         type: 'is-danger'
  //   //       });
  //   //     });
  //   // }
  // },
  methods: {
    reRenderDetails() {
       this.renderDetailsKey++;
    },
    reRenderUpdate() {
       this.renderUpdateKey++;
    },
    reRenderForm() {
       this.renderFormKey++;
    },
    fetchCitizen() {
      const sortBy = this.sortOrder + this.sortField;
      this.$store
        .dispatch('citizens/fetchCitizens', {
          filter: {
            page: this.currentPage,
            limit: 10,
            sort: sortBy,
            searchTerm:this.searchTe,
            searchType:this.searchTy
          },
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.fetchCitizen();
    },
    onSort(field, order) {
      // console.log(field, order);
      this.sortField = field;
      if (order === 'desc') {
        this.sortOrder = '-';
      } else {
        this.sortOrder = '+';
      }
      this.fetchCitizen();
      //   this.loadAsyncData();
    },
    trashModal(trashObject) {
      this.trashObject = trashObject;
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.editObject = editObject;
      this.reRenderUpdate();
      this.isEditModalActive = true;
    },
    editStatusModal(editStatusObject) {
      this.editStatusObject = editStatusObject;
      // this.$nextTick(() => {
         this.reRenderForm();
  // Okay, now that everything is destroyed, lets build it up again
  this.isEditStatusModalActive = true
// });
      // this.isEditStatusModalActive = true;
    },
    editDetailsModal(editDetailsObject) {
      this.editDetailsObject = editDetailsObject;
      this.reRenderDetails();
      this.isEditDetailsModalActive = true;
    },
    viewModal(viewObject) {
    this.viewObject = viewObject;
    this.isViewModalActive = true;
    },
    trashConfirm() {
      this.$store
        .dispatch('citizens/deleteCitizenWithId', this.trashObject._id)
        .then(() => {
          this.isModalActive = false;
          this.$buefy.snackbar.open({
            message: 'User Deleted Successfully',
            queue: false,
          });
        })
        .catch((err) => {
          this.isModalActive = false;
          this.$buefy.snackbar.open({
            message: 'Failed to delete user',
            queue: false,
          });
        });
    },
    editConfirm() {
      // console.log('Update Pressed');
    },
    trashCancel() {
      this.isModalActive = false;
    },
    editCancel() {
      this.isEditModalActive = false;
    },
    editStatusCancel() {
      // this.reRender();
      this.isEditStatusModalActive = false;
    },
    editDetailsCancel() {
      this.isEditDetailsModalActive = false;
    },
    viewCancel(){
    this.isViewModalActive = false;
    }
  },
};
</script>

<style scoped>
/* .is-rounded {
  object-fit: cover;
  height: auto;
} */
.scroll { 
     display: block;
    overflow-x: auto;
    white-space: nowrap;
} 
.image-cropper {
  width: 50px;
  height: 50px;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
}

.profile-pic {
  margin: 0 auto;
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.cell-class {
  color: black;
}
.column{
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 1.5em;
  padding-bottom: 0.5em;
}
.external{
  color: crimson;
}
.beautify {
  background-color: #F3F1F5;
}
</style>
